// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cities-block .list-container[data-v-859b80fc]{display:flex;flex-wrap:wrap;justify-content:center}", ""]);
// Exports
module.exports = exports;
